import { Web3ModalProvider } from './components/Web3ModalProvider'
import { BrowserRouter as Router } from 'react-router-dom'
import { Navigation } from './components/Navigation'
import AppRoutes from './routes'

function App() {
  return (
    <Web3ModalProvider>
      <Router>
        <Navigation />
        <main className="pt-16">
          <AppRoutes />
        </main>
      </Router>
    </Web3ModalProvider>
  )
}

export default App 